import React from 'react';

const CONF_LEVELS = [
  { val: 0, color: "#ddd", label: "No Confidence", emoji: "😶" },
  { val: 1, color: "#e55b5b", label: "Low", emoji: "😬" },
  { val: 2, color: "#f6ad55", label: "Medium", emoji: "😐" },
  { val: 3, color: "#3fbb6c", label: "High", emoji: "😃" }
];

function ConfidenceMeter({ value = 0, onChange, readOnly = false }) {
  return (
    <div
      className="confidence-meter"
      aria-label="Confidence Meter"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {CONF_LEVELS.slice(1).map(level => (
          <span
            key={level.val}
            className={level.val <= value ? 'active' : ''}
            onClick={
              readOnly ? undefined : () => onChange && onChange(level.val)
            }
            tabIndex={readOnly ? -1 : 0}
            onKeyDown={readOnly ? undefined : (e) => {
              if ((e.key === 'Enter' || e.key === ' ') && onChange) onChange(level.val);
            }}
            role="button"
            aria-label={level.label + " Confidence"}
            style={{
              cursor: readOnly ? 'default' : 'pointer',
              fontSize: value === level.val ? '2.1em' : '1.7em',
              color: level.val <= value ? level.color : "#bbb",
              marginRight: 0,
              userSelect: 'none',
              transition: 'font-size 0.18s, color 0.18s'
            }}
            title={level.label + " Confidence"}
          >●</span>
        ))}
      </div>
      <span
        style={{
          fontSize: 17,
          color: CONF_LEVELS[value]?.color || "#888",
          minWidth: 90,
          fontWeight: 500,
          whiteSpace: "nowrap"
        }}
      >
        {CONF_LEVELS[value]?.label || "—"} {CONF_LEVELS[value]?.emoji || ""}
      </span>
    </div>
  );
}

export default ConfidenceMeter;
